import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  List,
  ListItem,
  ListItemText
} from '@material-ui/core';
import ImportExportIcon from '@material-ui/icons/ImportExport';

interface Props {
  open: boolean;
  onClose: () => void;
  headers: { name: string }[];
  nonSortable: string[];
  onOpenMenu: (e: React.MouseEvent<HTMLElement>, column: string) => void;
}


export const ChequeListSortFilterColumnModal = ({
  open,
  onClose,
  headers,
  nonSortable,
  onOpenMenu
}: Props) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Sort Columns</DialogTitle>
      <DialogContent>
        <List>
          {headers?.map((header, index) =>
            !nonSortable.includes(header.name) ? (
              <ListItem
                key={index}
                button
                onClick={(e) => onOpenMenu(e, header.name)}
              >
                <ListItemText primary={header.name} />
                <IconButton size="small">
                  <ImportExportIcon fontSize="inherit" />
                </IconButton>
              </ListItem>
            ) : null
          )}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};
